import { render } from "./HomeDashboard.vue?vue&type=template&id=54e0a7e0"
import script from "./HomeDashboard.vue?vue&type=script&lang=js"
export * from "./HomeDashboard.vue?vue&type=script&lang=js"

import "./HomeDashboard.vue?vue&type=style&index=0&id=54e0a7e0&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__